import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, message, Modal, Input } from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco, SearchIco, PlusSmallIco, MinusSmallIco, InputSearchIco, ModalCloseIco,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import { OWNACCOUNT } from "constants/constants";

import {getAccounts, Account, getOldAccounts, getSavedDocuments} from "../../../../services/account";
import { getCurrentCompany, getUserData } from "../../../../services/user";
import { SelectOptions } from "../../../../services/form";
import { newTransfer } from "../../../../services/Transfers/OwnTransfer";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import { getOwnAccountDocumentNumber } from "../../../../services/Accounts/DocumentNumber";
import TemplatePopup from "components/TemplatePopup";

import {
    getAccountType, GetCustomerBenefAccount, GetCustomerBenefAccountData,
    GetCustomerByIban,
    GetCustomerDataByIban
} from "../../../../services/Transfers/GetCustomerByIban";
import { getOldCards } from "../../../../services/BrCards/OldCards";
import { upsertTemplate } from "../../../../services/Transfers/Templates";
import SaveAsTemplate from "components/SaveAsTemplate";
import { useLocation } from "react-router-dom";
import { getCustomerCommission } from "../../../../services/Customers/Commission";
import FullScreenLoading from "components/FullScreenLoading";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {deleteFileById} from "../../../../services/Transfers/Files";
import { log } from 'console'




const OwnAccount: React.FC<any> = ({ ownProps, ibanNumber }) => {
    const {t} = useTranslation()
    const modalDataInitial = {
        modalTitle: t("transfers.internalToOwnAccount"),
        groups: [
            {
                title: false,
                data: []
            }
        ],
        pdfFiles: [],
        buttons: [
            { save: true },
            { sign: true },
            { approve: true },
            { send: true }
        ]
    };
    const [visible, setVisible] = useState(false);
    const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>();
    const [toSelectOptions, setToSelectOptions] = useState<SelectOptions[]>();
    const [allAccounts, setAllAccounts] = useState<Account[]>();
    const [allAccountsWithOld, setAllAccountsWithOld] = useState<Account[]>();
    const [fromBranch, setFromBranch] = useState<Account>();
    const [toBranch, setToBranch] = useState<Account>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [modalData, setModalData] = useState(modalDataInitial);
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [userByIbanData, setUserByIbanData] = useState<GetCustomerByIban>();
    const [commissionLoading, setCommissionLoading] = useState(false);
    const [commissionAmount, setCommissionAmount] = useState('');
    const [ibanMessage, setIbanMessage] = useState<string>('');
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [pdfCount, setPdfCount] = useState(0);
    const [fileList, setFileList] = useState<any[]>([])
    const [fileUp, setFileUp] = useState<any[]>([])
    // const [deletefileList, setDeletefileList] = useState<any[]>([])
    const [tableData, setTableData] = useState<any[]>([])
    const [editOrRepeat,setEdit] = useState(false)
    const [form] = Form.useForm();
    const { setIbanNumber } = useActions();

    const location = useLocation();

    const fetchData = async () => {
        setLoadingAccount(true);
        const company = getCurrentCompany();
        const data = await getAccounts(company);
        const data1 = await getOldAccounts(company);
        let temp_data = [];
        let temp_data1 = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                temp_data1.push(row);
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`
                });
            }
        }
        if (data1 !== null && data1?.oldBusinessCards !== null && data1?.oldBusinessCards?.MainCards !== null) {
            for (let row1 of data1?.oldBusinessCards?.MainCards) {
                let additionCards = row1.AdditionCards;
                let additionCardsActive;
                if (row1.AdditionNumb > 0 && row1.CardStat !== "Active") {
                    additionCardsActive = additionCards?.find(line1 => line1.CardStat == "Active");
                }
                const line = {
                    "ACCOUNT_NO": row1.Pan,
                    "ACCOUNT_TYPE": "CARD-ACCOUNT",
                    "BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BALANCE_LC": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BLOCKSAMOUNT": "0",
                    "BLOCKSTATUS": "0",
                    "BRANCH_NAME": "BAS OFIS",
                    "BRANCH_NO": "801",
                    "CCY_NAME": row1.Currency,
                    "COMPASSACCOUNT": null,
                    "CREDIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "CUSTOMER_NO": company.customerNo,
                    "DEBIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "IBAN": row1?.Iban ?? '',
                    "INTEREST_ACC": "0",
                    "LAST_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "LAST_DAY_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "NICKNAME": row1?.Iban ?? '',
                    "OPENDATE": '',
                    "ORJ_IBAN": row1?.Iban ?? '',
                    "PRODUCT_CODE": "",
                    "PRODUCT_NAME": row1?.Name ?? '',
                    "REAL_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "STATUS": "1",
                    "WFA_AMOUNT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_COMMISSION": "0",
                    "WFA_CREDIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_DEBIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "ccyId": null,
                    "productId": null
                }
                temp_data1.push(line);
                // temp_data.push({
                //     label: line.IBAN,
                //     value: line.IBAN,
                //     extra: `${financial(line.BALANCE)} ${line.CCY_NAME}`
                // });
            }
        }
        setAllAccountsWithOld(temp_data1);
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        /**/
        if (location?.state?.trnData) {
            await fillCurrentForm(form, location.state.trnData);

            updateParentComponentFormData();
        }
        setLoadingAccount(false);
    };

    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements) {
            ownProps?.getFormElements({form});
        }
    }

    const loadData = async () => {
        console.log("loadData")
        console.log(location.state?.edit);
        setLoadingAccount(true);
        setLoadingData(true)
        const company = getCurrentCompany();
        const data = await getAccounts(company);
        const data1 = await getOldAccounts(company);
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        if (location.state?.edit){
            setEdit(true)
        } else{
            setEdit(false)
        }
        let temp_data = [];
        let temp_data1 = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                temp_data1.push(row);
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`
                });
            }
        }
        if (data1 !== null && data1?.oldBusinessCards !== null && data1?.oldBusinessCards?.MainCards !== null) {
            for (let row1 of data1?.oldBusinessCards?.MainCards) {
                let additionCards = row1.AdditionCards;
                let additionCardsActive;
                if (row1.AdditionNumb > 0 && row1.CardStat !== "Active") {
                    additionCardsActive = additionCards?.find(line1 => line1.CardStat == "Active");
                }
                const line = {
                    "ACCOUNT_NO": row1.Pan,
                    "ACCOUNT_TYPE": "CARD-ACCOUNT",
                    "BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BALANCE_LC": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BLOCKSAMOUNT": "0",
                    "BLOCKSTATUS": "0",
                    "BRANCH_NAME": "BAS OFIS",
                    "BRANCH_NO": "801",
                    "CCY_NAME": row1.Currency,
                    "COMPASSACCOUNT": null,
                    "CREDIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "CUSTOMER_NO": company.customerNo,
                    "DEBIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "IBAN": row1?.Iban ?? '',
                    "INTEREST_ACC": "0",
                    "LAST_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "LAST_DAY_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "NICKNAME": row1?.Iban ?? '',
                    "OPENDATE": '',
                    "ORJ_IBAN": row1?.Iban ?? '',
                    "PRODUCT_CODE": "",
                    "PRODUCT_NAME": row1?.Name ?? '',
                    "REAL_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "STATUS": "1",
                    "WFA_AMOUNT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_COMMISSION": "0",
                    "WFA_CREDIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_DEBIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "ccyId": null,
                    "productId": null
                }
                temp_data1.push(line);
                // temp_data.push({
                //     label: line.IBAN,
                //     value: line.IBAN,
                //     extra: `${financial(line.BALANCE)} ${line.CCY_NAME}`
                // });
            }
        }
        setAllAccountsWithOld(temp_data1);
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);

        /**/
        // if (location?.state?.data){
        //     await fillCurrentForm(form, location.state.data);
        //     updateParentComponentFormData();
        // }

        setTableData(location.state?.data)
        setFileList(pdf.data?.fileDetailsList)
        setLoadingAccount(false);
        if (location.state?.data !== undefined) {
            // set CUSTACC

            const value = location.state?.data['CUSTACC'];
            const findAccount = data?.find(row => row.IBAN == value && row.STATUS !== "0");
            if (findAccount !== undefined) {
                setFromBranch(findAccount);
                form.setFieldsValue({
                    "CUSTACC": location.state?.data['CUSTACC']
                })
            }

            const data2 = temp_data1?.filter(row => row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN);
            let temp_data2 = [];
            for (let row of data2) {
                // @ts-ignore
                temp_data2.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: row.CCY_NAME
                });
            }
            setToSelectOptions(old_data => temp_data2);
            // findUserByIban('');
            setToBranch(old_data => undefined);
            if (location.state?.edit)
                setIbankRef(location.state?.data['ibankRef'])
            setPdfCount(location.state?.data['attachedPDF'])
            if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) || location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if (location.state?.edit) {
                form.setFieldsValue({
                    'PMTCUSTID': location.state?.data['PMTCUSTID']
                });
            }
            form.setFieldsValue({
                'COMMAMOUNT': '0.00'
            });
            setCommissionAmount(old_value => '0.00')

            // set AMOUNT
            form.setFieldsValue({
                'AMOUNT': checkAmountForRequest(location.state?.data['trnAmount'])
            });
            form.setFieldsValue({
                'NOTE': location.state?.data['NOTE']
            });
            // set BENEFACC
            const findAccountBen = temp_data1?.find(row => row.IBAN == location.state?.data['BENEFACC']);
            const checkIban = data2?.filter(row => row.IBAN == location.state?.data['BENEFACC']);
            if (checkIban.length > 0) {
                form.setFieldsValue({
                    'BENEFACC': location.state?.data['BENEFACC']
                });
                setToBranch(old_data => findAccountBen);
                await findUserByIban1(location.state?.data['BENEFACC'], findAccount?.CCY_NAME);
            }
            // PMTDET
            form.setFieldsValue({
                'PMTDET': location.state?.data['PMTDET']
            });
        }
        setLoadingData(false)
    }

    const loadDataTemplate = async (tempData) => {
        console.log("loadDataTemplate")
        setLoadingData(true)
        if (tempData?.trnData !== undefined) {
            const docid = documentNumber;
            form.resetFields();
            if (tempData?.trnData) {
                fillCurrentFormTemplate(form, tempData?.trnData)
                updateParentComponentFormData();
            }
            if (docid !== "" && docid !== undefined) {
                form.setFieldsValue({
                    'PMTCUSTID': docid
                });
                setDocumentNumber(old_value => docid)
            }
            // set CUSTACC
            const value = tempData?.trnData.CUSTACC;
            const findAccount = allAccounts?.find(row => row.IBAN == value && row.STATUS !== "0");
            if (findAccount !== undefined) {
                setFromBranch(findAccount);
                
                    updateDocumentNumber();
                
                form.setFieldsValue({
                    "CUSTACC": tempData?.trnData.CUSTACC
                })
                const data2 = allAccountsWithOld?.filter(row => row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN);
                let temp_data2 = [];
                for (let row of data2) {
                    // @ts-ignore
                    temp_data2.push({
                        label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                        value: row.IBAN,
                        extra: row.CCY_NAME
                    });
                }
                setToSelectOptions(old_data => temp_data2);
            }

            setToBranch(old_data => undefined);
            console.log("trn",tempData?.trnData);
            
            form.setFieldsValue({
                'COMMAMOUNT': '0.00'
            });
            setCommissionAmount(old_value => '0.00')

            // set AMOUNT
            form.setFieldsValue({
                'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
            });

            form.setFieldsValue({
                'NOTE': tempData?.trnData.NOTE
            });
            // set BENEFACC
            const findAccountBen = allAccountsWithOld?.find(row => row.IBAN == tempData?.trnData.BENEFACC);
            if (findAccountBen !== undefined) {
                form.setFieldsValue({
                    'BENEFACC': tempData?.trnData.BENEFACC
                });
                setToBranch(old_data => findAccountBen);
                await findUserByIban1(tempData?.trnData.BENEFACC, findAccountBen?.CCY_NAME);
            }

            // PMTDET
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET
            });
        }
        setLoadingData(false)
    }

    const loadDataTemplate2 = async (tempData) => {
        console.log("loadDataTemplate2")
        setLoadingData(true)
        setLoadingAccount(true);

        const company = getCurrentCompany();
        const data = await getAccounts(company);
        const data1 = await getOldAccounts(company);
        let temp_data = [];
        let temp_data1 = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                temp_data1.push(row);
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`
                });
            }
        }
        if (data1 !== null && data1?.oldBusinessCards !== null && data1?.oldBusinessCards?.MainCards !== null) {
            for (let row1 of data1?.oldBusinessCards?.MainCards) {
                let additionCards = row1.AdditionCards;
                let additionCardsActive;
                if (row1.AdditionNumb > 0 && row1.CardStat !== "Active") {
                    additionCardsActive = additionCards?.find(line1 => line1.CardStat == "Active");
                }
                const line = {
                    "ACCOUNT_NO": row1.Pan,
                    "ACCOUNT_TYPE": "CARD-ACCOUNT",
                    "BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BALANCE_LC": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "BLOCKSAMOUNT": "0",
                    "BLOCKSTATUS": "0",
                    "BRANCH_NAME": "BAS OFIS",
                    "BRANCH_NO": "801",
                    "CCY_NAME": row1.Currency,
                    "COMPASSACCOUNT": null,
                    "CREDIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "CUSTOMER_NO": company.customerNo,
                    "DEBIT_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "IBAN": row1?.Iban ?? '',
                    "INTEREST_ACC": "0",
                    "LAST_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "LAST_DAY_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "NICKNAME": row1?.Iban ?? '',
                    "OPENDATE": '',
                    "ORJ_IBAN": row1?.Iban ?? '',
                    "PRODUCT_CODE": "",
                    "PRODUCT_NAME": row1?.Name ?? '',
                    "REAL_BALANCE": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "STATUS": "1",
                    "WFA_AMOUNT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_COMMISSION": "0",
                    "WFA_CREDIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "WFA_DEBIT": additionCardsActive?.Balance ?? (row1?.Balance ?? 0),
                    "ccyId": null,
                    "productId": null
                }
                temp_data1.push(line);
                // temp_data.push({
                //     label: line.IBAN,
                //     value: line.IBAN,
                //     extra: `${financial(line.BALANCE)} ${line.CCY_NAME}`
                // });
            }
        }
        setAllAccountsWithOld(temp_data1);
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        /**/

        setLoadingAccount(false);


        if (tempData?.trnData !== undefined) {
            // set CUSTACC
            const value = tempData?.trnData.CUSTACC;
            const findAccount = data?.find(row => row.IBAN == value && row.STATUS !== "0");
            if (findAccount !== undefined) {
                setFromBranch(findAccount);
               
                    await updateDocumentNumber();
                
                form.setFieldsValue({
                    "CUSTACC": tempData?.trnData.CUSTACC
                })
                const data2 = temp_data1?.filter(row => row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN);
                let temp_data2 = [];
                for (let row of data2) {
                    // @ts-ignore
                    temp_data2.push({
                        label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                        value: row.IBAN,
                        extra: row.CCY_NAME
                    });
                }
                setToSelectOptions(old_data => temp_data2);
            }

            setToBranch(old_data => undefined);

            form.setFieldsValue({
                'COMMAMOUNT': '0.00'
            });
            setCommissionAmount(old_value => '0.00')

            // set AMOUNT
            form.setFieldsValue({
                'AMOUNT': tempData?.trnData.AMOUNT
            });

            form.setFieldsValue({
                'NOTE': tempData?.trnData.NOTE
            });

            // set BENEFACC
            const findAccountBen = temp_data1?.find(row => row.IBAN == tempData?.trnData.BENEFACC);
            if (findAccountBen !== undefined) {
                form.setFieldsValue({
                    'BENEFACC': tempData?.trnData.BENEFACC
                });
                setToBranch(old_data => findAccountBen);
                await findUserByIban1(tempData?.trnData.BENEFACC, findAccountBen?.CCY_NAME);
            }

            // PMTDET
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET?.trim()
            });
        }
        updateParentComponentFormData()
        setLoadingData(false)
    }

    useEffect(() => {
        if (location.state?.data !== undefined) {
            loadData()
        }
        else if (location.state?.trnData) {
            loadDataTemplate2(location.state)
        }
        else{
            fetchData()
        }

        /**/

    }, [location.state]);

    const updateDocumentNumber = async () => {
        const document_number = await getOwnAccountDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID': document_number,
        });
        setDocumentNumber(old_value => document_number)
    }

    const getSelectedFromBranch = (value: any) => {
        const findAccount = allAccounts?.find(row => row.IBAN == value);
        setFromBranch(findAccount);

        updateToSelectOption(findAccount);
        findUserByIban('');
        setToBranch(old_data => undefined);
        /*getOldCards(getCurrentCompany()).then(res => {
            console.log(res)
        })*/

        if (!form.getFieldValue('PMTCUSTID') && value) {
            updateDocumentNumber();
        }

        form.setFieldsValue({
            'COMMAMOUNT': '0.00'
        });
        setCommissionAmount(old_value => '0.00')
    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        updateToSelectOption(findAccount);
        findUserByIban('');
        setToBranch(old_data => undefined);
        if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban){
            updateDocumentNumber();
        }

        form.setFieldsValue({
            'COMMAMOUNT' : '0.00'
        });

        setCommissionAmount(old_value =>  '0.00')

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

    const getSelectedToBranch = (value: any) => {
        form.setFieldsValue({
            "BENEFACCTYPE": ''
        })
        form.setFieldsValue({
            "BENEFNAME": ''
        })
        const findAccount = allAccountsWithOld?.find(row => row.IBAN == value);
        setToBranch(old_data => findAccount);
        findUserByIban(value);
    }

    const findUserByIban1 = async (value, ccy) => {
        let check_value = value.trim();

        setUserByIbanData(old_data => [])

        if (check_value.length) {
            const req_data = {
                pmtTypeCode: 'OWN_ACCOUNT',
                benefAcc: check_value !== undefined && check_value !== null ? check_value.toString().toUpperCase() : '' ,
                custAccCurr: ccy
            }
            const getData = await GetCustomerBenefAccountData(getCurrentCompany(), req_data);
            if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === "FAILURE") {
                setUserByIbanData(old_data => ({
                    ...old_data,
                    brAccountType: '',
                    customerName: '',
                    showError: true
                }))
                form.validateFields(['BENEFACC']);
            } else {
                setUserByIbanData(old_data => ({
                    ...old_data,
                    brAccountType: getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
                    customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
                    showError: false
                }))
            }
            setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
        } else {
            setUserByIbanData(old_data => [])
            form.setFieldsValue({ 'BENEFNAME': '' })
            form.setFieldsValue({ 'BENEFACCTYPE': '' })
            setIbanMessage('');
        }
    }

    const findUserByIban = async (value) => {
        let check_value = value.trim();

        setUserByIbanData(old_data => [])

        if (check_value.length) {
            const req_data = {
                pmtTypeCode: 'OWN_ACCOUNT',
                benefAcc: check_value !== undefined && check_value !== null ? check_value.toString().toUpperCase() : '' ,
                custAccCurr: fromBranch?.CCY_NAME
            }
            const getData = await GetCustomerBenefAccountData(getCurrentCompany(), req_data);
            if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === "FAILURE") {
                setUserByIbanData(old_data => ({
                    ...old_data,
                    brAccountType: '',
                    customerName: '',
                    showError: true
                }))
                form.validateFields(['BENEFACC']);
            } else {
                setUserByIbanData(old_data => ({
                    ...old_data,
                    brAccountType: getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
                    customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
                    showError: false
                }))
            }
            setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
        } else {
            setUserByIbanData(old_data => [])
            form.setFieldsValue({ 'BENEFNAME': '' })
            form.setFieldsValue({ 'BENEFACCTYPE': '' })
            setIbanMessage('');
        }
    }

    const updateToSelectOption = (findAccount) => {
        if(allAccountsWithOld !== undefined && findAccount !== undefined) {
            const data = allAccountsWithOld?.filter(row => row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN);
            let temp_data = [];

            for (let row of data) {
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: row.CCY_NAME
                });
            }

            setToSelectOptions(old_data => temp_data);
        }
    }

useEffect(() => {
    setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

    const newTransferFunc = async(RequestType: string) => {
        let pdf_files = form.getFieldValue('pdf_files') ?? [];

     if(ibankRef !== "") {
            await   deleteFileById(ibankRef)
            await new Promise(res => setTimeout(res, 1000)); 
           }
        // deletefileList?.map((row, index) => {
        //     deleteFileById(ibankRef, row.fileId)
        // })
        return newTransfer({
            trnRequestType: RequestType,
            ccy: 1,
            ccyType: fromBranch?.CCY_NAME,
            PMTCUSTID: form.getFieldValue('PMTCUSTID'),
            CUSTCIF: getCurrentCompany().customerNo,
            CUSTACC: fromBranch?.IBAN,
            AMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            BENEFACC: toBranch?.IBAN,
            PMTDET: form.getFieldValue('PMTDET'),
            COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMAMOUNT')),
            BENEFACCTYPE: form.getFieldValue('BENEFACCTYPE'),
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            NOTE: form.getFieldValue('NOTE'),
            ibankRef: ibankRef,
            attachedPDF: pdfCount || pdf_files.length
        })
    }

    const submitHandler = (args: any) => {
        let amount = financial(form.getFieldValue('AMOUNT'));
        let pdf_files = form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles = [];
        console.log("aa",pdf_files);
        
        if (pdf_files.length > 0) {
            for (let file of pdf_files) {
                modalDataInitial.pdfFiles.push({
                    'label': file.name,
                    'file': file
                })
            }
        }

        //@ts-ignore
        setModalData((old_data: any) => ({
            ...modalDataInitial,
            groups: [
                {
                    title: false,
                    data: [
                        // {
                        //     label : t("transfers.sourceOfCreation"),
                        //     value :  t("transfers.internetOffice")
                        // },
                        // {
                        //     label : t("transfers.transferType"),
                        //     value :  "Öz Hesabıma"
                        // },
                        {
                            label: t("transfers.sender"),
                            value: getCurrentCompany().name
                        },
                        {
                            label: t("salary.documentNo"),
                            value: `${args.PMTCUSTID}`
                        },
                        {
                            label: t("transfers.fromAccount"),
                            value: `${fromBranch?.IBAN}`
                        },
                        {
                            label: t("common.amount"),
                            value: `${amount} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label: t("transfers.accountNumber"),
                            value: `${toBranch?.IBAN}`
                        },
                        {
                            label: t("home.commission"),
                            value: `${financial(args.COMMAMOUNT)} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label: t("accountStatement.paymentDetails"),
                            value: `${args.PMTDET}`
                        },
                        args.NOTE !== undefined ? {
                            label: t("newTransfer.note"),
                            value: args.NOTE ?? ''
                        } : undefined,

                    ]
                }
            ],
        }))

        setNextModalVisible(old_value => true);
    }

    const getFileList = (info: any) => {
        form.setFieldsValue({
            'pdf_files': info.fileList
        });
    }

    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)
        }).catch(err_input_list => {

        })
    }
    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }

    const addOrEditPage = ownProps?.addOrEditPage || false;

    const onRefresh = () => {
        resetForm(form);
        setIbanMessage('');
    }

    const calculateCommission = (e) => {

        // form.setFieldsValue({
        //     'COMMAMOUNT' : '0.00'
        // });
        // setCommissionAmount(old_value =>  '0.00')

        // let value=checkAmountForRequest(e.target.value);

        // if (!isNaN(value)) {
        //     setCommissionLoading(true);
        //     getCustomerCommission({
        //         PAYMENT_TYPE : "OWN_ACCOUNT",
        //         CIF : getCurrentCompany().customerNo,
        //         CUSTACC : fromBranch?.IBAN,
        //         AMOUNT : value,
        //         CUR : fromBranch?.CCY_NAME,
        //         BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
        //         BENEFACC : form.getFieldValue('BENEFACC'),
        //         BENEFTAXID : form.getFieldValue('BENEFTAXID'),
        //         PMTDET : form.getFieldValue('PMTDET'),
        //     }).then(res => {
        //         setCommissionLoading(false);
        //
        //         form.setFieldsValue({
        //             'COMMAMOUNT' : res.COM_AMOUNT ?? ''
        //         });
        //         setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
        //     })
        // } else {
        //     setCommissionLoading(false);
        //
        //     form.setFieldsValue({
        //         'COMMAMOUNT' : ''
        //     });
        //     setCommissionAmount(old_value => '');
        // }
    }

    const removeFile = (index:any, editorRepeat: boolean)=> {
        // if(editorRepeat) {
        //     console.log("isledi removeFile");
        //     setDeletefileList(prevList => [...prevList, fileList[index]]);
        // }
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)

    }

    return (
        <>
            <Row>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px' }}
                                wrapperCol={{ flex: 1 }}
                                className='full OWN_ACCOUNT'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                form={form}
                                autoComplete="off"
                                onValuesChange={updateParentComponentFormData}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >
                                {
                                    !addOrEditPage && <div className='flex ' >
                                        <InputField
                                            labelItem={t("salary.documentNo")}
                                            placeholder={t("salary.automatically")}
                                            name={'PMTCUSTID'}
                                            required={true}
                                            form={form}
                                            value={documentNumber}
                                            message={true}
                                            maxLength={25}
                                            allowLatinNumber ={true}
                                        />


                                        <Button
                                            size={'large'}
                                            icon={<SaveIco />}
                                            className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                            onClick={e => setTemplatePopupVisible(true)}
                                        >
                                            {OWNACCOUNT.PATTERN}
                                        </Button>
                                    </div>
                                }

                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined}
                                    defaultValue={ibanNumber.iban}
                                />

                                <div className={'flex justify_between'} >

                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={fromBranch?.CCY_NAME}
                                        name={'AMOUNT'}
                                        form={form}
                                        className={`no_flex isDisabled amount_input ${addOrEditPage ? '' : 'commission_left'} `}
                                        required={true}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                    // onBlur={calculateCommission}
                                    />
                                    <InputField
                                        labelItem={t("home.commission")}
                                        placeholder=""
                                        className="commission_input commission_right commission_border isReadOnly"
                                        readOnly={true}
                                        suffix={fromBranch?.CCY_NAME}
                                        value={''}
                                        name={'COMMAMOUNT'}
                                        form={form}
                                        staticValue={true}
                                        hasLoading={commissionLoading}
                                        required={true}
                                        message={''}
                                        notValid={commissionAmount === ''}
                                    />
                                </div>
                                <div className={'flex pos_rel'}>
                                    <SelectField
                                        labelItem={t("deposit.accountNumber")}
                                        placeholder={t("accountStatement.chooseAccount")}
                                        options={toSelectOptions}
                                        name={'BENEFACC'}
                                        required={true}
                                        onChange={getSelectedToBranch}
                                        form={form}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        className={'is_upper_case isDisabled'}
                                        notFoundContent={t("newTransfer.noAccountCorrespondingCurrency")}
                                        message={''}
                                    />
                                    {
                                        userByIbanData?.showError && <span className={'form_error_span '}>{ibanMessage}</span>
                                    }
                                </div>
                                <InputField
                                    labelItem={t("newTransfer.accountType")}
                                    placeholder=""
                                    required={false}
                                    name={'BENEFACCTYPE'}
                                    className={'isReadOnly'}
                                    readOnly={true}
                                    form={form}
                                    value={fromBranch?.IBAN && toBranch?.IBAN && getAccountType(userByIbanData?.brAccountType)}
                                    // allowLatin={true}
                                />

                                <InputField
                                    labelItem={t("salary.accountHolder")}
                                    placeholder=""
                                    value={fromBranch?.IBAN && toBranch?.IBAN && userByIbanData?.customerName}
                                    className={'not_show_required_props isReadOnly'}
                                    readOnly={true}
                                    required={true}
                                    form={form}
                                    name={'BENEFNAME'}
                                    allowLatin={true}
                                />

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("accountStatement.paymentDetails")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'140'}
                                    name={'PMTDET'}
                                    required={true}
                                    form={form}
                                    // allowDestination={true}
                                    allowLatin={true}
                                    disabled={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                    className={'isDisabled'}
                                />

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            // className='not-required plus_minus_area'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            name={'NOTE'}
                                            form={form}
                                            disabled={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                            // allowAllSymboll={true}
                                            allowLatin={true}
                                            className={'isDisabled'}
                                        />

                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    form={form}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    fileLimit={10}
                                    checkSize={true}
                                    editOrRepeat={editOrRepeat}
                                    // fileListPdf={}
                                    disabled={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                    editFileList={fileList}
                                    tempFileList={fileUp}
                                    ibankRef={ibankRef}
                                    removeFile={removeFile}
                                />

                                {
                                    !addOrEditPage && <div className='flex button_row justify_between' >
                                        <Button
                                            size={'large'}
                                            icon={<SaveBlueIco />}
                                            className="light-button btn save_btn flex align_center justify_center"
                                            htmlType={"button"}
                                            onClick={openSaveAsTemplateModal}
                                        >
                                            {OWNACCOUNT.SAVE}
                                        </Button>

                                        <div className={'flex flex_wrap'}>
                                            <Button
                                                size={'large'}
                                                icon={<RefreshIco />}
                                                className="light-button refresh_btn btn flex align_center justify_center"
                                                onClick={onRefresh}
                                            >
                                                {t(OWNACCOUNT.REFRESH)}
                                            </Button>

                                            <Button
                                                size={'large'}
                                                htmlType="submit"
                                                className="blue-button next_btn btn flex align_center justify_center"
                                            >
                                                {OWNACCOUNT.NEXT}
                                            </Button>


                                        </div>

                                    </div>
                                }
                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransferFunc}
                visible={nextModalVisible}
                onClose={setNextModalVisible}
                data={modalData}
                repeatPdfList={fileList}
                className={'transfer_own_account'}
                nextModalTitle={t("home.transfer")}
                nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
                currentForm={form}
                transfer={true}
                tableData={tableData}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'OWN_ACCOUNT'}
                currentForm={form}
                updateAfterTemplate={updateDocumentNumberAndCommission}
                // setFileList = {setFileUp}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'OWN_ACCOUNT'}
                currentForm={form}
            />

            {
                loadingData ? <FullScreenLoading /> : <></>
            }

        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any, ownProps: any,) => ({
    ownProps: ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnAccount)
